module.exports = __webpack_public_path__ + "media/components/Sponsors/Shared/Buttons/Round/pen-b3f030bff9f3f8bacd28ff1d59c8efe8.svg";